import * as _ from "lodash"

export function oneWayRecommended(flightResult) {
    try {
        let cheapestPUnitSortedArray = _.sortBy(flightResult.obflights, e => e.clientPricing.TotalAmount);
        // let cheapestPUnitSortedArray = _.sortBy(flightResult.obflights, e => e.clientPricing.TotalAmount, e => getDurationIn(e.obFlight));
        let quickestPUnitSortedArray = _.sortBy(flightResult.obflights, e => getDurationIn(e.obFlight), e => e.clientPricing.TotalAmount, );
        let obPUnitSortedArray = _.sortBy(flightResult.obflights, e => e.clientPricing.AdultPrice.Total);
        let earliestDepSortedArray = _.sortBy(flightResult.obflights, e => e.obFlight[0].flight.DepDate);
        let earliestArrSortedArray = _.sortBy(flightResult.obflights, e => e.obFlight[e.obFlight.length - 1].flight.ArrDate);
        let obDurationSortedArray = _.sortBy(flightResult.obflights, e => e.obFlight[0].flight.TotalDuration);

        let cheapestPackedUnit = {
            type: "Cheapest",
            pUnit: [cheapestPUnitSortedArray[0]],
            sortObDep: earliestDepSortedArray,
            sortObArr: earliestArrSortedArray,
            sortObList: obPUnitSortedArray,
            sortObDuration: obDurationSortedArray,
            clientPricing: cheapestPUnitSortedArray[0].clientPricing
        }

        let quickestPackedUnit = {
            type: "Quickest",
            pUnit: [quickestPUnitSortedArray[0]],
            clientPricing: quickestPUnitSortedArray[0].clientPricing
        };

        let bestPUnitIndex = flightResult.obflights.length - 1;

        for (let cheapestIndex = 0; cheapestIndex < cheapestPUnitSortedArray.length; cheapestIndex++) {

            for (let quickestIndex = 0; quickestIndex < quickestPUnitSortedArray.length; quickestIndex++) {

                if (cheapestPUnitSortedArray[cheapestIndex].pId == quickestPUnitSortedArray[quickestIndex].pId) {
                    if (bestPUnitIndex >= quickestIndex) bestPUnitIndex = quickestIndex;
                    else break;
                } else continue;
            }

            if (bestPUnitIndex <= cheapestIndex) break;
            else continue;
        }
        let filteredBest = _.filter(quickestPUnitSortedArray, e => e.clientPricing.TotalAmount == quickestPUnitSortedArray[bestPUnitIndex].clientPricing.TotalAmount);
        let sortedBest = _.sortBy(filteredBest, e => {
            return getDurationIn(e.obFlight);
        });

        let bestPackedUnit = {
            type: "Best",
            pUnit: [sortedBest[0]],
            clientPricing: sortedBest[0].clientPricing
        }

        return [cheapestPackedUnit, quickestPackedUnit, bestPackedUnit];
    } catch (err) {
        throw err;
    }


}

export function twoWayRecommended(flightResult) {
    try {
        let obCheapestPUnitSortedArray = _.sortBy(flightResult.obflights, e => e.clientPricing.TotalAmount, e => getDurationIn(e.obFlight));
        let obQuickestPUnitSortedArray = _.sortBy(flightResult.obflights, e => getDurationIn(e.obFlight), e => e.clientPricing.TotalAmount);
        let obPUnitSortedArray = _.sortBy(flightResult.obflights, e => e.clientPricing.AdultPrice.Total);
        let obearliestDepSortedArray = _.sortBy(flightResult.obflights, e => e.obFlight[0].flight.DepDate);
        let obearliestArrSortedArray = _.sortBy(flightResult.obflights, e => e.obFlight[e.obFlight.length - 1].flight.ArrDate);
        let obDurationSortedArray = _.sortBy(flightResult.obflights, e => e.obFlight[0].flight.TotalDuration);


        let ibCheapestPUnitSortedArray = _.sortBy(flightResult.ibflights, e => e.clientPricing.TotalAmount, e => getDurationIn(e.ibFlight));
        let ibQuickestPUnitSortedArray = _.sortBy(flightResult.ibflights, e => getDurationIn(e.ibFlight), e => e.clientPricing.TotalAmount);

        let ibPUnitSortedArray = _.sortBy(flightResult.ibflights, e => e.clientPricing.AdultPrice.Total);
        let ibearliestDepSortedArray = _.sortBy(flightResult.ibflights, e => e.ibFlight[0].flight.DepDate);
        let ibearliestArrSortedArray = _.sortBy(flightResult.ibflights, e => e.ibFlight[e.ibFlight.length - 1].flight.ArrDate);
        let ibDurationSortedArray = _.sortBy(flightResult.ibflights, e => e.ibFlight[0].flight.TotalDuration);


        let obCheapestPUnitSortedArrayFirst5 = _.take(obCheapestPUnitSortedArray, 5);
        let obQuickestPUnitSortedArrayFirst5 = _.take(obQuickestPUnitSortedArray, 5);
        let ibCheapestPUnitSortedArrayFirst5 = _.take(ibCheapestPUnitSortedArray, 5);
        let ibQuickestPUnitSortedArrayFirst5 = _.take(ibQuickestPUnitSortedArray, 5);

        let cheapestCombination = combineIbObFlights(obCheapestPUnitSortedArrayFirst5, ibCheapestPUnitSortedArrayFirst5);
        let quickestCombination = combineIbObFlights(obQuickestPUnitSortedArrayFirst5, ibQuickestPUnitSortedArrayFirst5);

        let sortedCheapestCombination=[];
        let sortedQuickestCombination=[];
        if(cheapestCombination && cheapestCombination.length!=0) 
        sortedCheapestCombination = _.sortBy(cheapestCombination, e => e.clientPricing.TotalAmount);
        // sortedCheapestCombination = _.sortBy(cheapestCombination, e => [e.DurationInMin,e.clientPricing.TotalAmount]);
        
        if(quickestCombination && quickestCombination.length!=0) 
        sortedQuickestCombination = _.sortBy(quickestCombination, e => [e.DurationInMin, e.clientPricing.TotalAmount]);
        

        let cheapestPackedUnit;
        if(sortedCheapestCombination && sortedCheapestCombination.length!=0){
        cheapestPackedUnit = {
            type: "Cheapest",
            pUnit: [sortedCheapestCombination[0].pUnits[0],
                sortedCheapestCombination[0].pUnits[1]
            ],
            sortObList: obPUnitSortedArray,
            sortIbList: ibPUnitSortedArray,
            sortObDep: obearliestDepSortedArray,
            sortObArr: obearliestArrSortedArray,
            sortIbDep: ibearliestDepSortedArray,
            sortIbArr: ibearliestArrSortedArray,
            sortObDuration: obDurationSortedArray,
            sortIbDuration: ibDurationSortedArray,

            clientPricing: sortedCheapestCombination[0].clientPricing
        };
    }

        let quickestPackedUnit;
        if (sortedQuickestCombination && sortedQuickestCombination.length != 0 && sortedQuickestCombination[0].pUnits)
            quickestPackedUnit = {
                type: "Quickest",
                pUnit: [sortedQuickestCombination[0].pUnits[0],
                    sortedQuickestCombination[0].pUnits[1]
                ],

                clientPricing: sortedQuickestCombination[0].clientPricing
            };


        let bestPUnitIndex = sortedQuickestCombination.length - 1;

        for (let cheapestIndex = 0; cheapestIndex < sortedCheapestCombination.length; cheapestIndex++) {

            for (let quickestIndex = 0; quickestIndex < sortedQuickestCombination.length; quickestIndex++) {

                if (sortedCheapestCombination[cheapestIndex].pUnits[0].pId == sortedQuickestCombination[quickestIndex].pUnits[0].pId) {
                    if (bestPUnitIndex >= quickestIndex) {
                        bestPUnitIndex = quickestIndex
                        break;
                    } else break;
                } else continue;
            }

            if (bestPUnitIndex <= cheapestIndex) break;
            else continue;
        }


        let filteredBest = _.filter(sortedQuickestCombination, e => e.clientPricing.TotalAmount ==
            sortedQuickestCombination[bestPUnitIndex].clientPricing.TotalAmount);
        let sortedBest = _.sortBy(filteredBest, e => e.DurationInMin, e => e.clientPricing.TotalAmount);

        let bestPackedUnit;
        if (sortedBest && sortedBest.length != 0 && sortedBest[0].pUnits)
            bestPackedUnit = {
                type: "Best",
                pUnit: [
                    ...sortedBest[0].pUnits,
                ],

                clientPricing: sortedBest[0].clientPricing
            }

        return [cheapestPackedUnit, quickestPackedUnit, bestPackedUnit];
    } catch (err) {
        throw err;
    }
}

function combineIbObFlights(obFlightList, ibFlightList) {
    try {
        let RTMergedUnitList = [];

        for (let obFlight of obFlightList) {

            if (obFlight.matchingId && obFlight.matchingId.length > 0) {
                obFlight.matchingId.forEach(id => {
                    for (let ibFlight of ibFlightList) {
                        if (ibFlight.pId == id) {
                            let RTPackedUnit = getRTMergedUnit(obFlight, ibFlight);
                            RTMergedUnitList.push(RTPackedUnit);
                        }
                    }
                })
            } else {
                for (let ibFlight of ibFlightList) {
                    if (!ibFlight.matchingId) {
                        let RTPackedUnit = getRTMergedUnit(obFlight, ibFlight);
                        RTMergedUnitList.push(RTPackedUnit);
                    }
                }
            }
        };

        return RTMergedUnitList;


    } catch (err) {
        throw err;
    }
}

function getRTMergedUnit(obFlight, ibFlight) {
    try {
        let combinedPUnits = {
            pUnits: [obFlight, ibFlight],
            clientPricing: clientPriceMerge(obFlight.clientPricing, ibFlight.clientPricing),
            DurationInMin: getDurationIn(obFlight.obFlight) + getDurationIn(ibFlight.ibFlight)
        }

        return combinedPUnits;

    } catch (err) {
        throw err;
    }
}

function getDurationIn(flight) {
    try {

        let totalTime = 0;
        flight.forEach(flights => {
            totalTime += flights.flight.DurationInMin
        });
        return totalTime;
    } catch (err) {
        throw err;
    }
}



function clientPriceMerge(inBoundPricing, outBoundPricing) {
    try {

        let newPricing = {
            Currency: inBoundPricing.Currency,
            TotalAmount: inBoundPricing.TotalAmount + outBoundPricing.TotalAmount,
            TotalBaseFare: inBoundPricing.TotalBaseFare + outBoundPricing.TotalBaseFare,
            TotalTax: inBoundPricing.TotalTax + outBoundPricing.TotalTax,
            AdultPrice: inBoundPricing.AdultPrice && outBoundPricing.AdultPrice ? onePriceMerge(inBoundPricing.AdultPrice, outBoundPricing.AdultPrice) : undefined,
            ChildPrice: inBoundPricing.ChildPrice && outBoundPricing.ChildPrice ? onePriceMerge(inBoundPricing.ChildPrice, outBoundPricing.ChildPrice) : undefined,
            InfantPrice: inBoundPricing.InfantPrice && outBoundPricing.InfantPrice ? onePriceMerge(inBoundPricing.InfantPrice, outBoundPricing.InfantPrice) : undefined,
        }
        return newPricing;
    } catch (err) {
        throw err;
    }
}

function onePriceMerge(ibPrice, obPrice) {
    try {
        let newPrice = {
            BaseFare: ibPrice.BaseFare + obPrice.BaseFare,
            Tax: ibPrice.Tax + obPrice.Tax,
            Total: ibPrice.Total + obPrice.Total,
        }
        return newPrice;
    } catch (err) {
        throw err;
    }
}